import { useContext } from "react";
import { ThemeContext } from "../../../../contexts";
import { PlanHeaderProps, VEBPlanHeaderProps } from "../../../../types/components/planHeader.types";
import { Grid } from "@mui/material";

import CodeIcon from "@mui/icons-material/Code";
import DateRangeIcon from "@mui/icons-material/DateRange";

import "./planHeader.css";

const VEBPlanHeader = ({ planName, effectiveDate, planCode }: VEBPlanHeaderProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);

	return (
		<div className="plan-header">
			<div className="header-logo">
				<div>
					<div className="header">{planName}</div>
					{effectiveDate && (
						<div
							className="sub-header"
							style={{ color: theme.primary_color, borderLeftColor: theme.primary_color }}
						>
							<div>
								<DateRangeIcon className="icon" style={{ color: theme.primary_color }} />
							</div>
							<div className="code-text">Effective Date: {effectiveDate}</div>
						</div>
					)}
					{planCode && (
						<div
							className="sub-header2"
							style={{ color: theme.primary_color, borderLeftColor: theme.primary_color }}
						>
							<div>
								<CodeIcon className="icon" style={{ color: theme.primary_color }} />
							</div>
							<div className="code-text">Plan Code: {planCode}</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default VEBPlanHeader;
